import { createContext, useContext } from "react";
import { conferenceLocalStorage } from "../tools";
import { FetcherBase } from "./fetcher";

export class Translation extends FetcherBase {
    translations: Record<string, string>;

    async fetch(): Promise<any> {
        const response = await fetch(`/static/translations/${this.locale}.json?_${Date.now()}`);
        this.translations = await response.json();
    }

    get(id: string) {
        return this.translations[id] || id;
    }

    get locale(): string {
        const userLang = conferenceLocalStorage.profile?.locale ?? navigator.language.split("-")[0];
        return window.existingLanguageTags.indexOf(userLang) === -1 ? window.existingLanguageTags[0] : userLang;
    }
}

export const TranslationContext = createContext(undefined);

export function useTranslation(): Translation {
    return useContext(TranslationContext);
}
